import { render, staticRenderFns } from "./InviteMailBox.vue?vue&type=template&id=2dca4722&scoped=true&"
import script from "./InviteMailBox.vue?vue&type=script&lang=ts&"
export * from "./InviteMailBox.vue?vue&type=script&lang=ts&"
import style0 from "./InviteMailBox.vue?vue&type=style&index=0&id=2dca4722&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca4722",
  null
  
)

export default component.exports